import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import authService from './auth.service'

function Login() {
  sessionStorage.clear()
  sessionStorage.searchTerm = ""
  const history = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [show] = useState(false)

  function handleFormSubmit(event: any) {
    event.preventDefault()
    authService.login(email, password).then(
      response => {
        if (response.status === 203) {
          alert(response.data.message)
        }
        if (response.status === 200) {
          //var user = authService.getCurrentUser()
          history('/Home')
        }
      },
      error => {
        //const resMessage = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
      }
    )
  }
  return (
    <div className="login">
      <div className="bg1" />
      <div className="bg2" />

      <div className="login-right">
        <h3 className="title">Cozinha & saúde</h3>

        <hr className="hrLogin" />
        <form onSubmit={handleFormSubmit}>
          <input
            required
            type="email"
            placeholder="E-mail"
            value={email}
            onChange={e => setEmail(e.target.value)}
          />
          <input
            required
            placeholder="Senha"
            type={show ? 'text' : 'password'}
            value={password}
            onChange={e => setPassword(e.target.value)}
          />
          <button className="enter-app">Entrar</button>
          <div className="lineLogin">
            <label className="recordPassword">
              <input
                className="checkBoxMemorizer"
                type="checkbox"
                placeholder="Lembrar senha!"
                defaultChecked={false}
              />
              <span className="spnCheckBox">Memorizar senha</span>
            </label>
            <button className="btnrecovery" disabled>
              Esqueci a senha
            </button>
          </div>
        </form>
      </div>

      <div className="bg3" />
    </div>
  )
}
export default Login
